import { render, staticRenderFns } from "./suspendPopup.vue?vue&type=template&id=347bf28f"
import script from "./suspendPopup.vue?vue&type=script&lang=js"
export * from "./suspendPopup.vue?vue&type=script&lang=js"
import style0 from "./suspendPopup.vue?vue&type=style&index=0&id=347bf28f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports